import "./newSponsor.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { DriveFolderUploadOutlined as UploadIcon } from "@mui/icons-material";
import { Button, TextField, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

const NewSponsor = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize navigate

  const { state } = useLocation(); // Access state passed from navigate
  const sponsorData = state?.sponsor || {}; // Extract sponsor data or use an empty object

  // populate formData with sponsorData if editing
  const [formData, setFormData] = useState({
    userId: sponsorData.userId || userIdRedux,
    fullName: sponsorData.fullName || "",
    fatherName: sponsorData.fatherName || "",
    motherName: sponsorData.motherName || "",
    phoneNumber: sponsorData.phoneNumber || "",
    address: sponsorData.address || "",
    tempAddress: sponsorData.tempAddress || "Not Available",
    occupation: sponsorData.occupation || "",
    detail: sponsorData.detail || "", //Cash or Commodities
    sponsorImages: sponsorData.image || "",
  });

  const [sponsorImages, setSponsorImages] = useState(sponsorData.image || "");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errors = {};

    if (!formData.fullName) errors.fullName = "Full Name is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.fullName))
    //   errors.fullName = "Full Name name must be a string.";

    // if (!formData.fatherName) errors.fatherName = "Father Name is required.";
    // if (formData.fatherName) {
    //   if (!/^[a-zA-Z\s]+$/.test(formData.fatherName))
    //     errors.fatherName = "Father Name name must be a string.";
    // }

    // if (!formData.motherName) errors.motherName = "Mother Name is required.";
    // if (formData.motherName) {
    //   if (!/^[a-zA-Z\s]+$/.test(formData.motherName))
    //     errors.motherName = "Mother Name name must be a string.";
    // }

    // if (!formData.phoneNumber) errors.phoneNumber = "Phone number is required.";
    if (formData.phoneNumber) {
      if (!/^\d{10}$/.test(formData.phoneNumber))
        errors.phoneNumber = "Phone number must be 10 digits.";
    }

    if (!formData.address) errors.address = "Address is required.";

    if (!formData.occupation) errors.occupation = "Occupation is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.occupation))
    //   errors.occupation = "Occupation name must be a string.";

    if (!formData.detail) errors.detail = "Detail for Sponsor is required.";

    if (sponsorImages.length === 0)
      errors.sponsorImages = "Please select single image to be uploaded.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSponsorImages(file);
      setFormData({ ...formData, sponsorImages: file });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setBackEndError("");

    const formDataToSubmit = new FormData();

    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("fullName", formData.fullName);
    formDataToSubmit.append("fatherName", formData.fatherName);
    formDataToSubmit.append("motherName", formData.motherName);
    formDataToSubmit.append("phoneNumber", formData.phoneNumber);
    formDataToSubmit.append("address", formData.address);
    formDataToSubmit.append("tempAddress", formData.tempAddress);
    formDataToSubmit.append("occupation", formData.occupation);
    formDataToSubmit.append("status", formData.status);
    formDataToSubmit.append("detail", formData.detail);
    if (sponsorImages) formDataToSubmit.append("sponsorImages", sponsorImages);

    /**
     *
     * choosing URL whether to update or add sponsor
     *
     */
    const MAIN_URL = sponsorData._id
      ? `${BASE_URL}/api/sponsor/updateSponsor/${sponsorData._id}`
      : `${BASE_URL}/api/sponsor/addSponsor`;

    let response = "";
    try {
      if (sponsorData._id) {
        response = await axios.put(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        response = await axios.post(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (response.status === 201) {
        setBackEndError(<font color="green">Success TO ADD DATA.</font>);
        navigate("/sponsor");
      } else if (response.status === 200) {
        setBackEndError(<font color="green">Success TO UPDATE DATA.</font>);
        navigate("/sponsor");
      } else if (response.status === 401) {
        //alert or show error message
        setBackEndError(<font color="red">USER ALREADY EXISTS.</font>);
      } else if (response.status === 400) {
        //alert or show error message
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      } else if (response.status === 402) {
        //alert or show error message
        setBackEndError(<font color="red">INVALID USER DATA.</font>);
      }
    } catch (error) {
      const errorMessage = error.response.data.msg;
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="fullName"
                label="Full Name"
                type="text"
                value={formData.fullName}
                onChange={handleChange}
                error={Boolean(errors.fullName)}
                helperText={errors.fullName}
                fullWidth
                margin="normal"
                required
              />
              <TextField
                style={{ flex: 3 }}
                name="occupation"
                label="Occupation"
                type="text"
                value={formData.occupation}
                onChange={handleChange}
                error={Boolean(errors.occupation)}
                helperText={errors.occupation}
                fullWidth
                margin="normal"
                required
              />

              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="fatherName"
                label="Father Name"
                type="text"
                value={formData.fatherName}
                onChange={handleChange}
                error={Boolean(errors.fatherName)}
                helperText={errors.fatherName}
                fullWidth
                margin="normal"
              />
              <TextField
                style={{ flex: 3 }}
                name="motherName"
                label="Mother Name"
                type="text"
                value={formData.motherName}
                onChange={handleChange}
                error={Boolean(errors.motherName)}
                helperText={errors.motherName}
                fullWidth
                margin="normal"
              />

              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="address"
                label="Address"
                type="text"
                value={formData.address}
                onChange={handleChange}
                error={Boolean(errors.address)}
                helperText={errors.address}
                fullWidth
                margin="normal"
                required
              />
              <TextField
                style={{ flex: 3 }}
                name="tempAddress"
                label="Temporary Address"
                type="text"
                value={formData.tempAddress}
                onChange={handleChange}
                // error={Boolean(errors.motherName)}
                // helperText={errors.motherName}
                fullWidth
                margin="normal"
                required
              />

              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="phoneNumber"
                label="Phone Number"
                type="number"
                value={formData.phoneNumber}
                onChange={handleChange}
                error={Boolean(errors.phoneNumber)}
                helperText={errors.phoneNumber}
                fullWidth
                margin="normal"
              />
              {/* Another TextField or empty space for 1/4 size */}
              <TextField
                style={{ flex: 3 }}
                name="detail"
                label="Sponsor Detail"
                type="text"
                value={formData.detail}
                onChange={handleChange}
                error={Boolean(errors.detail)}
                helperText={errors.detail}
                fullWidth
                margin="normal"
                required
              />
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<UploadIcon />}
                style={{ margin: "10px 0" }}
              >
                Upload Image
                <input
                  id="image"
                  name="image"
                  type="file"
                  multiple
                  hidden
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Button>
            </div>
            {errors.sponsorImages && (
              <span className="error-message">{errors.sponsorImages}</span>
            )}
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {sponsorImages && (
                <img
                  src={
                    sponsorImages instanceof File
                      ? URL.createObjectURL(sponsorImages)
                      : sponsorImages
                  }
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              )}
            </div>

            <span className="error-message">{backEndError}</span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" /> // Show loading spinner
              ) : (
                "Save"
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewSponsor;
